import Reports from "./report";


export default class Project{
    constructor(headers){
		this.headers=headers;
		this.reports = new Reports(headers);
	}
	


	async get(pid){
		try{
			const projectDetailsRequest = await fetch(`/api/v1/projects/${pid}`,{headers:this.headers})
			if(projectDetailsRequest.status!==200) throw new Error({error: "PROJECT NOT FOUND"})
			const projectDetails = await projectDetailsRequest.json();
			projectDetails.readonly=projectDetails.readonly || false;
			return projectDetails
		}
		catch(e){
			console.log(e)
			throw e
		}
	}

	async history(uuid,branch){
		try{
			const request = await fetch(`/api/v1/reports/${uuid}/history?limit=20&branch=${branch}`,{
				headers: this.headers
			})
			if(request.status!==200) throw await request.json();
			const historyInfo = await request.json();
			return historyInfo

		}
		catch(e){
			console.log(e)
			throw e
		}
	}

	async getFullHistory(pid, history){

		return history

		// const data = []
		// for (const entry of history){
		// 	try{
		// 		data.push(await this.reports.get(pid, entry.uuid))
		// 	}
		// 	catch(e){
		// 		continue
		// 	}
		// }
		// return data
	}


    // preprocessFullReport(){
	// 	this.flattenSameLibraryAdvices()
	// 	this.correctLicensingVulnerabilities();
    //     return {
    //         dataNeededToRender: this.dataNeededToRender,
    //         ...this.generateExclusionsMap()
    //     }
	// }
    // flattenSameLibraryAdvices(){
	// 	this.dataNeededToRender.report.security.assessments.map((assessment)=>{
	// 		const {reports}=assessment;
    // 		const libraries=[];
    // 		reports.map(({dependency})=>{
	// 			if(!libraries.includes(dependency.library.name+":"+dependency.version))libraries.push(dependency.library.name+":"+dependency.version);
	// 			return null
    // 		})
	// 		const newAssessmentReports = [];
    // 		libraries.map(library=>{
    // 			let sameLibrary=reports.filter(({dependency})=>dependency.library.name+":"+dependency.version===library)
	// 			if(sameLibrary.length>0){
    // 				const allAdvices=[];
    // 				sameLibrary.map(({advices})=>{
    // 					return advices.map(advice=>{
	//     					allAdvices.push(advice)
	//     					return null;
	// 					})
	// 				})
	// 				sameLibrary=sameLibrary[0];
    // 				sameLibrary.advices=allAdvices;
	// 				newAssessmentReports.push(sameLibrary);
	// 			}
	// 			return null;
    // 		})
	// 		assessment.reports=newAssessmentReports;
	// 		return null;
    // 	})
    // }
    //temporary fix waiting for fix in the backend
	// correctLicensingVulnerabilities(){
	// 	const total=this.dataNeededToRender.report.licensing.reports.reduce((tot,report)=>{
	// 		const partial=report.results.reduce((acc,result)=>{
	// 			acc.violations+=result.violations.length;
	// 			acc.warnings+=result.warnings.length;
	// 			return acc;
	// 		},{violations:0, warnings:0})
	// 		report.warningsCount=partial.warnings;
	// 		report.violationsCount=partial.violations;
	// 		tot.violations+=partial.violations;
	// 		tot.warnings+=partial.warnings;
	// 		return tot;
	// 	},{violations:0,warnings:0})
	// 	this.dataNeededToRender.report.licensing.warningsCount=total.warnings;
	// 	this.dataNeededToRender.report.licensing.violationsCount=total.violations;
    // }
    // generateExclusionsMap(){
	// 	if(this.dataNeededToRender.report.status==="OK" || this.dataNeededToRender.report.status==="PARTIAL"){
	// 		//mark exclusions
	// 		const mitigations=this.dataNeededToRender.report.exclusions;
    //         let exclusionsMap={};
	// 		for(let section in mitigations){
	// 			const sectionObject=mitigations[section];
	// 			for(let exclusionType in sectionObject){
	// 				exclusionType=sectionObject[exclusionType];
	// 				exclusionType.map(exclusion=>{
	// 					if(!exclusion.id || exclusionsMap[exclusion.id]) {
	// 						return null;
	// 					}
	// 					exclusionsMap={...exclusionsMap, [exclusion.id]: exclusion}; return null;
	// 				})
	// 			}
	// 		}
	// 		return {
    //             exclusionsMap
    //         }
	// 	}
    // }
    // async recomputeProject(pid,branch,requestStatus,headers){
    //     if(requestStatus===200){
	//             const projectDataRequest= await fetch(`/api/v1/reports/${pid}/full?branch=${branch}`,{
    //             method: 'POST',
    //             headers
    //         })
    //         if(projectDataRequest.status!==200) throw {error:"ERROR"}
    //         const projectData= await projectDataRequest.json();
    //         this.dataNeededToRender.report=projectData;
    //         return this.preprocessFullReport();
    //     }
    // }
    // async mitigate(newMitigation,userUUID, urlParams, headers){
	// 	window.$("#loading").modal({backdrop: 'static'});
	// 	newMitigation.creatorUuid=userUUID;
	// 	newMitigation.content=JSON.stringify(newMitigation.content)
	// 	const {pid,branch}=urlParams;
    //     try{

    //         const mitigationRequest= await fetch(`/api/v2/exclusions/${pid}/${encode(branch)}`,{
    //             method: 'POST', 
    //             headers,
    //             body: JSON.stringify(newMitigation)
    //         })
    //         const recomputedData=await this.recomputeProject(pid,branch, mitigationRequest.status,headers);
    //         return recomputedData;
    //     }
	// 	catch(e){
	// 		throw e
	// 	}
    // }
    // async demitigate(advice,urlParams,headers){
	// 	const {pid,branch}=urlParams;
    //     window.$("#loading").modal({backdrop: 'static'});
    //     try{
    //         const demitigationRequest=await fetch(`/api/v2/exclusions/${pid}/${encode(branch)}/${advice}`,{
    //             method: 'DELETE',
    //             headers
    //         })
    //         const recomputedData=await this.recomputeProject(pid,branch, demitigationRequest.status,headers);
    //         return recomputedData;
    //     }
	// 	catch(e){
	// 		throw e;
	// 	}
    // }

	// async fixLicense(id, licenseToFix, urlParams, headers){
	// 	const {pid,branch}=urlParams;
	// 	let {library,version}=licenseToFix;
	// 	window.$("#loading").modal({backdrop: 'static'});
	// 	const url='/api/v1/licenses/library/'+encode(library.language)+'/'+encode(library.name)+'/'+encode(version)+"/"+id;
    //     try{
    //         const licenseFixRequest= await fetch(url, {
	// 			method:'POST', 
	// 			headers: {
	// 				...headers, "Content-Type":"text/plain"
	// 			}
	// 		})
	// 		const recomputedData=await this.recomputeProject(pid,branch, licenseFixRequest.status, headers);
    //         setTimeout(()=>window.$("#loading").modal('toggle'),500);
    //         return recomputedData;
            
    //     }
	// 	catch(e){
	// 		setTimeout(()=>window.$("#loading").modal('toggle'),500);
	// 	}
	// }
	
}